/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import config from 'js/app/config';

import { Link } from '@coursera/cds-core';

import ChatFooter from 'bundles/ai-coach-platform/components/patterns/chat/ChatFooter';

import _t from 'i18n!nls/search-common';

const styles = {
  privacyNotice: css`
    color: inherit !important;
  `,
};

const CoachChatFooter = () => {
  return (
    <ChatFooter>
      <FormattedMessage
        message={_t(
          'Powered by AI—check for errors and avoid sharing sensitive info. Data is handled per {privacyNotice}.'
        )}
        privacyNotice={
          <Link
            href={`${config.url.base}about/privacy?trk_ref=coach`}
            target="_blank"
            rel="noreferrer"
            css={styles.privacyNotice}
          >
            {_t("Coursera's Privacy Notice")}
          </Link>
        }
      />
    </ChatFooter>
  );
};

export default CoachChatFooter;
